<template>
  <forgerock-template id="info-page" :title="$t(`dss.page.${key}.title`)">

    <div>
      <label id="info" class="mb-4">{{ $t(`dss.page.${key}.info`) }}</label>
    </div>

    <div class="buttons">
      <a id="continue" class="btn btn-primary" :href="$t(`dss.page.${key}.link_url`)" v-if="$te(`dss.page.${key}.link_url`)">
        {{ $t(`dss.page.${key}.link_name`) }}
      </a>
    </div>

  </forgerock-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ForgerockTemplate from '@/components/layout/ForgerockTemplate.vue';

export default defineComponent({
  name: 'InfoPage',
  components: { ForgerockTemplate },
  computed: {
    key() {
      return this.$route.params.key;
    },
  },
});
</script>

<style scoped>
</style>
